import {
    CONFIRMED_GET_PROPERTY_SUMMARY,
    CONFIRMED_GET_PROPERTY_COUNT_BY_MONTH,
    CONFIRMED_GET_PROPERTY_COUNT_BY_STATE,
    CONFIRMED_GET_PROPERTY_COUNT_BY_DISTRICT
} from '../actions/Report/ReportTypes';
const initialState = {
    propertySummary: {},
    propertyCountByMonth: [],
    stateDataMap: {},
    districtDataMap: {}
};

function ReportReducer(state = initialState, actions) {
    switch (actions.type) {
        case CONFIRMED_GET_PROPERTY_SUMMARY:
            return {
                ...state,
                propertySummary: actions.payload.data,
            };
        case CONFIRMED_GET_PROPERTY_COUNT_BY_MONTH:
            return {
                ...state,
                propertyCountByMonth: actions.payload.data,
            };
        case CONFIRMED_GET_PROPERTY_COUNT_BY_STATE:
            return {
                ...state,
                stateDataMap: actions.payload.data,
            };
        case CONFIRMED_GET_PROPERTY_COUNT_BY_DISTRICT:
            return {
                ...state,
                districtDataMap: actions.payload.data,
            };
        default:
            return state;
    }
}

export {ReportReducer};